<!-- A one-click action Claude asked for: drawn before the approval card so an ask that arrives on top of it stays on top. -->
<div
  *ngIf="overlayConfirmations.current as card"
  class="approval-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="overlay-confirm-title"
>
  <div class="approval-backdrop"></div>
  <div class="approval-card">
    <div class="approval-header">
      <h2 id="overlay-confirm-title" class="approval-title">{{ card.title }}</h2>
    </div>

    <p class="approval-request">{{ card.says }}</p>

    <p *ngIf="card.failure" class="approval-failure" role="alert">{{ card.failure }}</p>

    <div class="approval-actions">
      <button
        class="approval-btn approval-btn--decline"
        (click)="overlayConfirmations.decline()"
        [disabled]="!card.armed || card.running"
        type="button"
      >
        Decline
      </button>
      <button
        class="approval-btn approval-btn--approve"
        (click)="overlayConfirmations.confirm()"
        [disabled]="!card.armed || card.running"
        type="button"
      >
        {{ card.running ? 'Working...' : card.failure ? 'Try again' : card.confirmLabel }}
      </button>
    </div>
  </div>
</div>

<!-- Approval layer: fixed overlay, invisible when idle, rendered only in the desktop app. -->
<div
  *ngIf="approvalService.currentAsk"
  class="approval-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="approval-title"
>
  <div class="approval-backdrop"></div>
  <div class="approval-card">
    <div class="approval-header">
      <h2 id="approval-title" class="approval-title">{{ approvalService.currentAsk!.title }}</h2>
      <span class="approval-countdown" aria-live="polite">{{ approvalService.formatCountdown() }}</span>
    </div>

    <p *ngIf="approvalService.currentAsk!.request" class="approval-request">{{ approvalService.currentAsk!.request }}</p>

    <ul *ngIf="approvalService.currentAsk!.details.length > 0" class="approval-details">
      <li *ngFor="let d of approvalService.currentAsk!.details">{{ d }}</li>
    </ul>

    <p *ngIf="approvalService.waitingCount > 0" class="approval-waiting">{{ approvalService.waitingCount }} more waiting</p>

    <div class="approval-actions">
      <button
        class="approval-btn approval-btn--decline"
        (click)="approvalService.choose('declined')"
        [disabled]="!approvalService.buttonsArmed"
        type="button"
      >
        Decline
      </button>
      <button
        class="approval-btn approval-btn--approve"
        (click)="approvalService.choose('approved')"
        [disabled]="!approvalService.buttonsArmed"
        type="button"
      >
        Approve
      </button>
    </div>
  </div>
</div>

<!-- This session's asks and how each ended, so the builder can see what Claude was allowed to do. -->
<div *ngIf="approvalService.history.length > 0" class="history-toggle">
  <button class="history-btn" (click)="toggleHistory()" type="button">
    {{ showHistory ? 'Hide' : 'Show' }} history ({{ approvalService.history.length }})
  </button>
</div>

<div *ngIf="showHistory && approvalService.history.length > 0" class="history-panel">
  <div *ngFor="let entry of approvalService.history" class="history-entry">
    <span class="history-kind" [attr.data-kind]="entry.ask.kind">{{ entry.ask.kind }}</span>
    <span class="history-title">{{ entry.ask.title }}</span>
    <span class="history-answer" [attr.data-answer]="entry.answer">{{ entry.answer }}</span>
    <span class="history-time">{{ entry.timestamp | date:'HH:mm' }}</span>
  </div>
</div>
